import { storeToRefs } from "pinia";

import {
  printAmazonBarcodeLabel,
  printEmployeeBadgeLabel,
  printProductBarcodeLabel,
  printRetailBarcodeLabel,
} from "@/services/blackfisk/printer";
import { usePrinterStore } from "@/stores/printer";

import { useRequestErrorToast } from "./useRequestErrorToast";

async function printProductBarcode(
  serverPrinterId = 0,
  barcode = "",
  sku = "",
  title = "",
): Promise<void> {
  if (serverPrinterId > 0 && barcode.length > 0 && sku.length > 0 && title.length > 0) {
    const errors = await printProductBarcodeLabel(serverPrinterId, barcode, sku, title);
    if (errors?.length ?? 0) {
      useRequestErrorToast(errors, "Error printing Product Barcode");
    }
  }
}

async function printRetailBarcode(
  serverPrinterId = 0,
  productId = 0,
  channelId = 0,
): Promise<void> {
  if (serverPrinterId > 0 && productId > 0 && channelId > 0) {
    const errors = await printRetailBarcodeLabel(serverPrinterId, productId, channelId);
    if (errors?.length ?? 0) {
      useRequestErrorToast(errors, "Error printing Retail Barcode");
    }
  }
}

async function printEmployeeBadge(serverPrinterId = 0, userId = 0): Promise<void> {
  if (serverPrinterId > 0 && userId > 0) {
    const errors = await printEmployeeBadgeLabel(serverPrinterId, userId);
    if (errors?.length ?? 0) {
      useRequestErrorToast(errors, "Error printing Retail Barcode");
    }
  }
}

async function printAmazonBarcode(
  serverPrinterId = 0,
  fnsku = "",
  labelSku = "",
  labelTitle = "",
  labelCondition = "",
  quantity = 1,
): Promise<void> {
  if (serverPrinterId > 0 && fnsku.length > 0 && quantity > 0) {
    const errors = await printAmazonBarcodeLabel(
      serverPrinterId,
      fnsku,
      labelSku,
      labelTitle,
      labelCondition,
      quantity,
    );
    if (errors?.length ?? 0) {
      useRequestErrorToast(errors, "Error printing Retail Barcode");
    }
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const usePrinters = () => {
  const PrinterStore = usePrinterStore();
  const { labelConfiguration, refreshPrinters, refreshPapers } = PrinterStore;
  const { accountPrinters, papers, labelPrinterMap } = storeToRefs(PrinterStore);
  const refreshPrintersAndPaper = (): void => {
    // ? Will these run only when needed?
    // * Caching controlled by server header.
    refreshPrinters();
    refreshPapers();
  };
  return {
    refreshPrintersAndPaper,
    printProductBarcode,
    printRetailBarcode,
    printEmployeeBadge,
    printAmazonBarcode,
    labelConfiguration,
    accountPrinters,
    papers,
    labelPrinterMap,
  };
};
